/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { EnvironmentModel } from '@core/models';

export const environment: EnvironmentModel = {
  production: true,
  envCode: 'prod',
  appCode: 'BIB',
  apiBaseUrl:
    'https://raven.bitvarklab.com/api/public/64c7be226cff71fd021943db/self-smart-cq',
  securityBaseUrl:
    'https://raven.bitvarklab.com/api/public/64c7be226cff71fd021943db/self-smart-cq'
};
